export function operacaoCotaDistribOrgaoInRequest(params = {}) {
  return {
    type: '@operacaocotadistriborgao/VISUACOTADISTRIBORGAO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoCotaDistribOrgao(orga_codigo) {
  return {
    type: '@operacaocotadistriborgao/FIND_VISUACOTADISTRIBORGAO',
    payload: { orga_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaocotadistriborgao/FAILED_REQUEST',
  };
}

export function deleteOperacaoCotaDistribOrgao(orga_codigo, params) {
  return {
    type: '@operacaocotadistriborgao/DELETE_VISUACOTADISTRIBORGAO',
    payload: { orga_codigo, params },
  };
}

export function updateOperacaoCotaDistribOrgao(operacaocotadistriborgao, params) {
  return {
    type: '@operacaocotadistriborgao/UPDATE_VISUACOTADISTRIBORGAO',
    payload: { operacaocotadistriborgao, params },
  };
}

export function storeOperacaoCotaDistribOrgao(operacaocotadistriborgao, params) {
  return {
    type: '@operacaocotadistriborgao/STORE_VISUACOTADISTRIBORGAO',
    payload: { operacaocotadistriborgao, params },
  };
}

export function successInRequest(
  operacaocotadistriborgao,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaocotadistriborgao/SUCCESS_IN_REQUEST',
    payload: { operacaocotadistriborgao, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaocotadistriborgao) {
  return {
    type: '@operacaocotadistriborgao/SUCCESS_REQUEST',
    payload: { operacaocotadistriborgao },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaocotadistriborgao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaocotadistriborgao/RECORD_FILTERING',
    payload: { params },
  };
}
